module.exports = __webpack_public_path__ + "static/media/ic_instagram.ba534bdd.svg";